<template>
    <b-form-group :label-cols-sm="labelColsSm" :label-cols-lg="labelColsLg" :description="description" :label-for="id" label-class="fs-14 grey-color fw-700 align-items-baseline" :label-align="labelRight ? 'right' : 'left'" :class="compact ? 'mb-0' : ''">
        <template #label>
            {{ label }}:
            <span v-if="!!hint" class="atmo-help">
                &nbsp;<i class="atmo-icon-question-mark"></i><span class="atmo-help__text">{{ hint }}</span>
            </span>
        </template>
        <p :id="id" class="fs-14 grey-color my-auto col-form-label" :class="valueClass">{{ value ? trueText : falseText }}</p>
    </b-form-group>
</template>

<script>
export default {
    name: 'text-row-boolean-text',
    props: {
        label: {
            type: String,
            required: true
        },
        value: {
            type: Boolean,
            required: true
        },
        description: {
            type: String,
            default: ''
        },
        compact: {
            type: Boolean,
            default: false
        },
        labelColsLg: {
            type: Number,
            default: 3
        },
        labelColsSm: {
            type: Number,
            default: 4
        },
        valueClass: {
            type: String,
            default: ''
        },
        labelRight: {
            type: Boolean,
            default: false
        },
        hint: {
            type: String,
            default: ''
        },
        trueText: {
            type: String,
            default: 'Да'
        },
        falseText: {
            type: String,
            default: 'Нет'
        }
    },
    computed: {
        id() {
            return 'text_row_boolean_text_' + this._uid;
        }
    }
};
</script>

<style scoped>
.form-row {
    margin-left: 0;
    margin-right: 0;
}
</style>
<style>
.form-row > .col > .text-muted {
    margin-top: 0;
    font-size: 12px;
    font-style: italic;
}
</style>
